<template>
	<div>
		<Modal
			:is-open="isOpen"
			title="Undelete Account"
			@close="closeModal"
		>
			<template #body>
				<div class="undelete-content">
					<div class="restore-icon">♻️</div>
					<h3>Restore Account</h3>

					<div class="user-details">
						<h4>Account Details</h4>
						<div class="user-detail-row">
							<strong>Name:</strong> {{ user.name }}
						</div>
						<div class="user-detail-row">
							<strong>Email:</strong> {{ user.email }}
						</div>
						<div class="user-detail-row">
							<strong>Created:</strong> {{ formatDate(user.created) }}
						</div>
						<div class="user-detail-row">
							<strong>Deleted:</strong> {{ formatDate(user.deleted_date) }}
						</div>
					</div>
					<div v-if="errorMessage" class="message error">
						{{ errorMessage }}
					</div>
					<div v-else-if="successMessage" class="message success">
						{{ successMessage }}
					</div>
				</div>
			</template>

			<template #actions>
				<button @click="closeModal" :disabled="processing">
					Cancel
				</button>
				<button @click="undelete" :disabled="processing">
					{{ actionLabel }}
				</button>
			</template>
		</Modal>
	</div>
</template>

<script>
import Modal from './Modal.vue';
import util from '@/util';

export default {
	name: 'undelete-user-modal',
	components: {
		Modal
	},
	store: ['users'],
	props: {
		isOpen: {
			type: Boolean,
			default: false
		},
		userId: {
			type: Number
		}
	},
	computed: {
		user() {
			return this.users[this.userId] || {
				user_uuid: null
			}
		}
	},

	data() {
		return {
			showUndeleteModal: false,
			errorMessage: null,
			successMessage: null,
			actionLabel: 'Undelete',
			processing: false
		}
	},

	methods: {
		closeModal() {
			if (!this.processing) {
				this.$emit('close');
				this.resetForm();
			}
		},

		resetForm() {
			this.errorMessage = null;
			this.successMessage = null;
			this.actionLabel = 'Undelete';
			this.processing = false;
		},

		undelete() {
			this.errorMessage = null;
			this.successMessage = null;
			this.actionLabel = 'Undeleting...';
			this.processing = true;

			this.$http.patch(`/users/${this.user.id}/undelete`)
				.then((response) => {
					if (response.data.success) {
						this.actionLabel = 'Undelete Successful';
						this.successMessage = 'Account has been successfully restored!';

						// Auto close after success
						setTimeout(() => {
							this.closeModal();
							this.$emit('close');
						}, 2000);
					} else {
						this.actionLabel = 'Undelete';
						this.processing = false;

						if (response.data.default_email_in_use) {
							this.errorMessage = 'The default email address is in use on another account';
						} else if (response.data.all_emails_in_use) {
							this.errorMessage = 'All email addresses are in use on other accounts';
						} else {
							this.errorMessage = 'An error occurred during undelete';
						}
					}
				})
				.catch((error) => {
					this.actionLabel = 'Undelete';
					this.processing = false;
					this.errorMessage = error.response?.data?.message || 'An error occurred during undelete';
					console.error('Undelete failed:', error);
				});
		},

		formatDate(date) {
			return util.formatDate(date);
		}
	}
}
</script>

<style scoped>
	.undelete-content {
		padding: 20px 0;
	}

	.restore-icon {
		font-size: 48px;
		margin-bottom: 16px;
		text-align: center;
	}

	.undelete-content h3 {
		margin: 0 0 20px 0;
		font-size: 20px;
		color: #333;
		text-align: center;
	}

	.user-details {
		background: #f8f9fa;
		padding: 16px;
		border-radius: 8px;
		margin-bottom: 20px;
	}

	.user-details h4 {
		margin: 0 0 12px 0;
		font-size: 16px;
		color: #495057;
	}

	.user-detail-row {
		margin-bottom: 8px;
		color: #666;
	}

	.user-detail-row strong {
		color: #333;
		margin-right: 8px;
	}

	.message {
		padding: 12px;
		border-radius: 4px;
		text-align: center;
	}

	.message.success {
		background: #d4edda;
		color: #155724;
		border: 1px solid #c3e6cb;
	}

	.message.error {
		background: #f8d7da;
		color: #721c24;
		border: 1px solid #f5c6cb;
	}
</style>
